import React from 'react';

const Register: React.FC = () => {
  return (
    <div className="min-h-screen flex items-center justify-center">
      <div className="text-center">
        <h1 className="text-2xl font-bold text-gray-900">Register Page</h1>
        <p className="text-gray-600 mt-2">Registration functionality will be implemented here.</p>
      </div>
    </div>
  );
};

export default Register;
